<template>
    <div style="height:200px">
      <vue-apex-charts
        :options="chartOptions"
        :series="series"
      ></vue-apex-charts>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "Radial",
  data: () => ({
    porcentaje: 0,
    color: 'grey',
    series: [0],
    chartOptions: {
      colors: ["#7460ee"],
      chart: {
        type: "radialBar",
        offsetY: -20
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#e7e7e7",
            strokeWidth: "97%",
            margin: 5, // margin is in pixels
            dropshadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: "#999",
              opacity: 1,
              blur: 2
            }
          },
          dataLabels: {
            name: {
              show: true
            },
            value: {
              offsetY: 5,
              fontSize: "25px"
            }
          }
        }
      },
      fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
          },
      },
      labels: ["Avance"],
      tooltip: {
        theme: "dark"
      },
      yaxis: {
              max: 100,
              min: 0
            }
    }
  }),
  created() {
    this.getPorcentaje()
    this.getColor()
  },
  props: ["id", "numerador", "denominador"],
  components: {
    VueApexCharts
  },
  methods: {
    getPorcentaje() {
      this.porcentaje = Math.round(this.numerador/this.denominador*10000)/100
      if(this.denominador != 0){
        this.series[0] = this.porcentaje
      }
    },
    getColor(){
      if(this.porcentaje <= 75){
        this.color = "#F44336";
      }
      else if(this.porcentaje <= 89){
        this.color = "#FFEB30"
      }
      else{
        this.color = "#4CAF50"
      }
      this.chartOptions.colors[0] = this.color;
    }
  }
};
</script>